import {createReducer, on} from "@ngrx/store";
import * as GroupActions from './group.actions';
import * as AccountActions from '../account/account.actions';
import { initialGroupState } from "./group.state";
import { SchoolGroupStatus } from "@core/models/domain/group.domain";

export const groupReducer = createReducer(
    initialGroupState,

    // LOAD GROUPS
    on(GroupActions.loadGroups, state => ({
        ...state,
        loading: true,
        error: null
    })),
    on(GroupActions.loadGroupsSuccess, (state, { groups }) => {
        // Keep locally created groups if the read model hasn't caught up yet.
        const fetchedById = new Set(groups.map(g => g.id).filter(Boolean));
        const optimisticOnly = state.groups.filter(g => g?.id && !fetchedById.has(g.id));
        return {
            ...state,
            loading: false,
            groups: [...groups, ...optimisticOnly],
            loaded: true,
            lastLoadedAt: Date.now()
        };
    }),

    // A Wonde sync rewrites groups server-side: invalidate the cache so the next
    // loadGroupsIfNeeded fetches fresh data.
    on(AccountActions.syncRunFinished, state => ({
        ...state,
        loaded: false
    })),
    on(GroupActions.loadGroupsFailure, (state, { error }) => ({
        ...state,
        loading: false,
        error
    })),

    // CREATE GROUP
    on(GroupActions.createGroup, state => ({
        ...state,
        loading: true
    })),
    on(GroupActions.createGroupSuccess, (state, { group }) => ({
        ...state,
        loading: false,
        groups: [...state.groups, {
            ...group,
            status: group?.status ?? SchoolGroupStatus.ACTIVE
        }]
    })),
    on(GroupActions.createGroupFailure, (state, { error }) => ({
        ...state,
        loading: false,
        error
    })),

    // UPDATE GROUP
    on(GroupActions.updateGroup, state => ({
        ...state,
        loading: true
    })),
    on(GroupActions.updateGroupSuccess, (state, { group }) => {
        const updated = state.groups.map(g => (g.id === group.id ? group : g));
        return { ...state, loading: false, groups: updated };
    }),
    on(GroupActions.updateGroupFailure, (state, { error }) => ({
        ...state,
        loading: false,
        error
    })),

    // DELETE GROUP
    on(GroupActions.deleteGroup, state => ({
        ...state,
        loading: true
    })),
    on(GroupActions.deleteGroupSuccess, (state, { groupId }) => ({
        ...state,
        loading: false,
        groups: state.groups.filter(g => g.id !== groupId)
    })),
    on(GroupActions.deleteGroupBlocked, state => ({
        ...state,
        loading: false
    })),
    on(GroupActions.deleteGroupFailure, (state, { error }) => ({
        ...state,
        loading: false,
        error
    }))
);